import styled from "styled-components";

const Title = styled.h1`
  font-weight: 500;
  font-size: 5rem;
`;

export default Title;
